import { ChangeEvent, FunctionComponent, memo, useCallback } from 'react';

import classNames from 'classnames';
import classes from './Switch.module.scss';

interface SwitchProps {
  checked: boolean;
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  switchFirst?: boolean;
  className?: string;
  onChange: (checked: boolean) => void;
}

export const Switch: FunctionComponent<SwitchProps> = memo(
  ({ checked, label, ariaLabel, disabled, switchFirst, className, onChange }) => {
    const onChangeHandler = useCallback(
      ({ target }: ChangeEvent<HTMLInputElement>) => {
        onChange(target.checked);
      },
      [onChange]
    );

    return (
      <label
        className={classNames(
          classes['switch'],
          {
            [classes['switch--switch-first']]: switchFirst,
            [classes['switch--disabled']]: disabled,
          },
          className
        )}
      >
        {label && <span className={classes['switch__label']}>{label}</span>}
        <div className={classes['switch__container']}>
          <input
            type={'checkbox'}
            className={classes['switch__input']}
            checked={checked}
            disabled={disabled}
            onChange={onChangeHandler}
            {...(ariaLabel && { 'aria-label': ariaLabel })}
          />
          <div className={classes['switch__slide']}></div>
        </div>
      </label>
    );
  }
);
